module.exports = __webpack_public_path__ + "static/media/clinic_icon.a3d8f9f8.png";